import dayjs from "dayjs";

const dateFormatter = (date, format, ignoreUTC = true) => {
  //NB: ignoreUTC if true skips convertion of utc datetime to local datetime and returns it as it is
  format = format ? format : "YYYY-MM-DDTHH:mm";
  let a = new Date(date);

  if (a.getDate()) {
    if (ignoreUTC === true) {
      date = date.toLowerCase().replace("z", "");
    }
    return dayjs(date).format(format);
  } else return "";
};

export default dateFormatter;
